import CustomReportsAdminColumnRenderer from './customReportsAdminColumnRenderer.component';
import CheckboxCellRenderer from '../../shared/agGrid/cellRenderers/checkboxCellRenderer.component';
import { alignCenterCellStyle, alignLeftCellStyle } from '@common/cellStyles';
import { adminColumnSharedFields } from '../columnDefinitions';

export default [
  {
    headerName: 'Report ID',
    field: 'reportSetId',
    width: 220,
    minWidth: 200,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Report Name',
    field: 'reportSetName',
    width: 400,
    minWidth: 200,
    sort: 'asc',
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Report Type',
    field: 'customReportType',
    ...alignLeftCellStyle,
  },
];

export const adminColumn = {
  field: 'reportSetId',
  cellRenderer: CustomReportsAdminColumnRenderer,
  ...adminColumnSharedFields,
};


export const customFlagColumn = changeDisplayFlag => ({
  headerName: 'Display',
  cellRenderer: CheckboxCellRenderer(),
  cellRendererParams: {
    isChecked: flagEnabled => flagEnabled,
    onSelect: (value, rowData) => changeDisplayFlag(value, rowData),
  },
  field: 'customReportFlag',
  width: 400,
  minWidth: 200,
  ...alignCenterCellStyle,
});

